import rm from "./rm"

const { default: userUtils } = require("../manager/userUtils")
const { default: api } = require("./api")

//网络请求。废弃
function get(url, success, fail, method = 'GET', postdata = '', header = {}) {
  url = url.replace('http://', 'https://')
  requestX({
    url: url,
    data: {},
    method: method,
    // OPTIONS, GET, HEAD, POST, PUT, DELETE, TRACE, CONNECT
    header: header ? header : 'application/json',
    mode: 'cors',
    // 设置请求的 header
    success: function (res) {
      success(res)
    },
    fail: function (ex) {
      fail(ex)
    },
    complete: function () { },
  })
}

/**
 * 通用网络请求，非200响应归为错误
 */
function request(
  url,
  success,
  fail,
  method = 'GET',
  postdata = '',
  header = undefined
) {
  if (typeof url == typeof undefined || url.length == 0) {
    fail({
      data: {
        Msgs: ['接口地址错误'],
      },
    })
    return
  }
  url = url.replace('http://', 'https://')
  requestX({
    url: url,
    data: postdata,
    method: method,
    // OPTIONS, GET, HEAD, POST, PUT, DELETE, TRACE, CONNECT
    header: Object.assign({
      "content-type": 'application/json'
    }, header || {}),
    mode: 'cors',
    // 设置请求的 header
    success: function (res) {
      if (res.statusCode === 200) {
        success(res)
      } else {
        fail(res)
      }
    },
    fail: function (ex) {
      fail({
        statusCode: 0,
        ex: ex,
      })
    },
  })
}

/**
 * 针对商城API接口数据格式再封装
 */
function link(apiParams, method, postData, needAuth, callback) {
  var apiUrl = ''
  if (typeof apiParams === 'object') {
    apiUrl = api.get(apiParams.apiName)
    for (var paramName in apiParams) {
      if (paramName !== 'apiName') {
        var paramValue = apiParams[paramName]
        if (apiUrl.indexOf('{' + paramName + '}') !== -1) {
          // api中已经有该参数值的占位符
          apiUrl = apiUrl.replace('{' + paramName + '}', paramValue)
        } else {
          if (apiUrl.indexOf('?') !== -1) {
            apiUrl += '&' + paramName + '=' + paramValue
          } else {
            apiUrl += '?' + paramName + '=' + paramValue
          }
        }
      }
    }
  } else {
    apiUrl = api.get(apiParams)
  }

  request(
    apiUrl,
    function (res) {
      res.apiUrl = apiUrl
      if (res.data.Success) {
        callback(
          true,
          res,
          res.data.Msgs && res.data.Msgs.length > 0
            ? res.data.Msgs[0]
            : method == 'POST'
              ? '提交成功'
              : '获取成功'
        )
      } else {
        callback(
          false,
          res,
          res.data.Msgs && res.data.Msgs.length > 0
            ? res.data.Msgs[0]
            : method == 'POST'
              ? '提交失败'
              : '获取失败'
        )
      }
    },
    function (res) {
      console.log("request", apiUrl, res)
      res.apiUrl = apiUrl
      var tips = '无法连接服务器'
      if (res.data && res.data.Msgs && res.data.Msgs.length > 0) {
        tips = res.data.Msgs[0]
      } else if (res.statusCode >= 500 && res.statusCode < 600) {
        tips = '服务器错误' + res.statusCode
      } else if (res.statusCode == 404) {
        tips = '资源不存在404'
      } else if (res.statusCode > 0) {
        tips = '请求错误' + res.statusCode
      }
      callback(false, res, tips)
    },
    method,
    typeof postData === 'object' ? JSON.stringify(postData) : postData,
    needAuth ? userUtils.getAuthHeader() : undefined,
    // app.getAuthHeader(needAuth)
  )
}

const test = window.location.href.indexOf("192.168.") != -1 || window.location.href.indexOf("localhost") != -1;

function requestX(data) {
  const method = (data.method || "GET").toUpperCase();
  if (test) {
    const resData = {
      url: data.url,
      method: method,
      header: {
        ...(Object.assign({
          "content-type": 'application/json',
        }, data.header ? data.header : {})),
      },
      ...(data.data && method === "POST" ? { data: JSON.parse(data.data) } : {})
    }
    rm.request(resData, function (res) {
      console.log("请求结果：", resData, res);
      data.success({
        statusCode: res.statusCode,
        data: res.data
      })
    })
  } else {
    fetch(data.url, {
      headers: Object.assign({
        "content-type": 'application/json'
      }, data.header ? data.header : {}),
      method: method,
      mode: 'cors',
      ...(data.data && method === "POST" ? { body: data.data } : {})
      // success: function(res){
      //   console.log("ddd", res)
      //   if(data.success){
      //     data.success(res)
      //   }
      // },
      // fail: function(ex){
      //   if(data.fail){
      //     data.fail(ex);
      //   }
      // },
      // complete: function(){

      // }
    }).then(res => {
      return new Promise(reslove => {
        res.json().then(json => {
          reslove({
            statusCode: res.status,
            data: json
          })
        })
      })
    }).then(res => {
      try {
        console.log(data.url, res)
        data.success(res)
      } catch (error) {
      }
    }).catch(res => {
      data.fail(res)
    })
  }

}

const httpUtil = {
  get: get,
  request: request,
  link: link,
  requestX,
}

export default httpUtil
